<section [@routerTransition]>
    <div class="row">
        <div class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="input-group">
                <img class="input-group-text" src="../../../../assets/img/icons/search.svg" alt="Buscar">
                <input type="text" [(ngModel)]="nameOrCnpj" id="txtSearchConvenio" placeholder="Busque por nome ou CNPJ"
                    (input)="refresh()">
            </div>
            <custom-dropdown class="btn-filter ml-1" [label]="'Filtrar'"
                [image]="'../../../../assets/img/icons/filter.svg'">
                <accordion [title]="'Status'">
                    <div class="custom-radio">
                        <input type="radio" id="ativo" name="status" [(ngModel)]="status" (click)="checkStatus(true)"
                            [value]="true">
                        <label class="font-primary-gray-900" for="ativo">Ativo</label><br>
                        <input type="radio" id="inativo" name="status" [(ngModel)]="status" (click)="checkStatus(false)"
                            [value]="false">
                        <label class="font-primary-gray-900" for="inativo">Inativo</label><br>
                    </div>
                    <button class="btn text-danger btn-limpar-filtro" (click)="limparFiltroStatus()">Limpar filtro
                        <i class="fas fa-trash-alt ml-1"></i>
                    </button>
                </accordion>
                <hr>
                <accordion [title]="'Modalidade'">
                    <div class="custom-radio">
                        <input type="radio" id="autoGestao" name="modalidade" [(ngModel)]="modalidade"
                            (click)="checkModalidade(true)" [value]="true">
                        <label class="font-primary-gray-900" for="autoGestao">Autogestão</label><br>
                        <input type="radio" id="tradicional" name="modalidade" [(ngModel)]="modalidade"
                            (click)="checkModalidade(false)" [value]="false">
                        <label class="font-primary-gray-900" for="tradicional">Gestão tradicional</label><br>
                    </div>
                    <button class="btn text-danger btn-limpar-filtro" (click)="limparFiltroModalidade()">Limpar filtro
                        <i class="fas fa-trash-alt ml-1"></i>
                    </button>
                </accordion>
            </custom-dropdown>
        </div>

        <div class="col p-0 d-flex justify-content-end">
            <button class="btn primary-white-button" (click)="create()">
                Cadastrar novo convênio
                <img src="../../../../assets/img/icons/add.svg" alt="Adicionar">
            </button>
        </div>
    </div>

    <div class="table-container table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Razão Social</th>
                    <th>CNPJ</th>
                    <th>Modalidade</th>
                    <th>Telefone</th>
                    <th>E-mail</th>
                    <th>Representante</th>
                    <th>Status</th>
                    <th>Ação</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="
                let convenio of convenios
                  | paginate
                    : {
                        id: 'server',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                    <td>{{convenio.razaoSocial}}</td>
                    <td>{{convenio.cnpj | mask: "00.000.000/0000-00"}}</td>
                    <td>{{convenio.autoGestao ? "Autogestão" : "Gestão tradicional"}}</td>
                    <td>{{stringService.getTelefoneFormatado(convenio.ddd, convenio.telefone)}}</td>
                    <td>{{convenio.email}}</td>
                    <td>{{convenio.representante}}</td>
                    <td>{{convenio.ativo ? "Ativo" : "Inativo"}}</td>
                    <td>
                        <div *ngIf="isCreateUser(convenio); else vinculoContainer">
                            <div *ngIf="convenio.ativo; else inativo">
                                <button title="Editar convênio" type="button" class="btn btn-icon"
                                    (click)="edit(convenio)">
                                    <img src="../../../../assets/img/icons/edit.svg" alt="Editar">
                                </button>
                                <button title="Desativar convênio" type="button"
                                    class="btn btn-icon btn-deletar-convenio ml-2" (click)="delete(convenio)">
                                    <img src="../../../../assets/img/icons/active.svg" alt="Desativar convênio">
                                </button>
                            </div>

                            <ng-template #inativo>
                                <button title="Ativar convênio" type="button" class="btn btn-icon"
                                    (click)="active(convenio)">
                                    <img src="../../../../assets/img/icons/deActive.svg" alt="Ativar convênio">
                                </button>
                            </ng-template>
                        </div>
                        <ng-template #vinculoContainer>
                            <div *ngIf="hasVinculo(convenio); else semVinculo">
                                <button title="Remover Vínculo" type="button" class="btn icon icon-danger"
                                    (click)="removeVinculo(convenio)">
                                    <i class="hgi hgi-stroke hgi-minus-sign-circle"></i>
                                </button>
                            </div>
                            
                            <ng-template #semVinculo>
                                <button title="Criar Vínculo" type="button" class="btn icon icon-blue"
                                    (click)="createVinculo(convenio)">
                                    <i class="hgi hgi-stroke hgi-plus-sign-circle"></i>
                                </button>
                            </ng-template>
                        </ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="float-sm-right m-auto">
                <abp-pagination-controls id="server" (pageChange)="getDataPage($event)">
                </abp-pagination-controls>
            </div>
        </div>
    </div>
</section>